import { storyblokEditable, StoryblokComponent, SbBlokData } from "@storyblok/react";
import { Page } from "@/.storyblok/types/319751/storyblok-components";

interface PageProps {
  blok: Page & SbBlokData;
}

const PageComponent: React.FC<PageProps> = ({ blok }) => (
  <main {...storyblokEditable(blok)} className="text-center mt-4">
    {blok.body?.map((nestedBlok) => (
      <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
    ))}
  </main>
);

export default PageComponent;
